module.exports = __webpack_public_path__ + "static/img/two-J.f3e5606.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/two-J.jpg
// module id = lmZz
// module chunks = 1